import type { GetTweets200PageAllOfThreeContentItemReferencedTweetTweetBasicInfoAllOfTwoTweetType } from './getTweets200PageAllOfThreeContentItemReferencedTweetTweetBasicInfoAllOfTwoTweetType';

export type GetTweets200PageAllOfThreeContentItemReferencedTweetTweetBasicInfoAllOfTwo = {
  content?: string;
  /** 트윗 유형 */
  tweetType?: GetTweets200PageAllOfThreeContentItemReferencedTweetTweetBasicInfoAllOfTwoTweetType;
};
